import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallbackPage() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  useEffect(() => {
    (async () => {
      await refresh();
      toast.success("Connexion Steam réussie");
      nav("/", { replace: true });
    })();
  }, [refresh, nav]);
  return <div className="py-24 text-center text-muted-foreground">Connexion en cours...</div>;
}
